import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Mission from "../components/Mission";
import Promise from "../components/Promise";
import Whychoose from "../components/Whychoose";
import Services from "../components/Services";
import Industries from "../components/Industries";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import '@fortawesome/fontawesome-free/css/all.min.css';

function Home() {
  return (
    <>
      <Header />
      <Hero />
      <Mission />
      <Services />
      <Industries />
      <Whychoose />
      <Promise />
      <Contact />
      <Footer />
    </>
  );
}

export default Home;